import React, { useEffect } from 'react'
import { useAuth } from 'react-oidc-context'
import logo from '../assets/TraQR_logo.png'
import '../styles/Logout.css'

function Logout() {
  const auth = useAuth()

  useEffect(() => {
    if (auth.isAuthenticated) {
      auth.removeUser()
      console.log('User is signed out')
    }
  }, [auth.isAuthenticated, auth])

  return (
    <div className="logout-container">
      <div className="logout-card">
        <img src={logo} alt="TraQR Logo" width={150} height={"auto"} />

        <h2 className="logout-title">You have been logged out</h2>

        <p className="logout-message">
          Thank you for using TraQR
        </p>
        <button
          onClick={() => auth.signinRedirect()}
          className="logout-signin-button"
          data-testid="signin-link"
        >
          Sign-In
        </button>
      </div>
    </div>
  )
}

export default Logout
